// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","link":"Footer_link__ljLIL"};